<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block" [class.component-dark-theme]="isToggled">
  <mat-card-header>
    <mat-card-title>
      <h5 class="mb-0">
        Obrazac za provjeru ispunjenja formalnih uvjeta
      </h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="complyForm" (ngSubmit)="submit()">
      @for (field of fields; track field) {
        <div>
          <div class="mb-25" appearance="fill">
            <p><strong>{{ field.label }}</strong></p>
            <mat-radio-group [formControlName]="field.control" class="d-flex flex-row">
              <mat-radio-button [value]="true">DA</mat-radio-button>
              <mat-radio-button [value]="false">NE</mat-radio-button>
              <mat-radio-button [value]="'NP'">NP</mat-radio-button>
            </mat-radio-group>
          </div>
          @if (complyForm.get(field.control)?.invalid && complyForm.get(field.control)?.touched) {
            <div class="error text-danger">
              Molimo odaberite DA, NE ili NIJE PRIMJENJIVO NP.
            </div>
          }
        </div>
      }
      <button mat-raised-button color="primary" type="submit" [disabled]="complyForm.invalid">
        Podnesite obrazac
      </button>
    </form>
  </mat-card-content>
</mat-card>